import { WidgetType } from "@codemirror/view";
import { t as translate } from "@magic-md/i18n";
import { attachSyntaxEditInteractions } from "../shared/widgets";

function tr(key: string, params?: Record<string, unknown>): string {
    return translate("editor", key, params);
}

export class PrettyHtmlCommentWidget extends WidgetType {
    constructor(
        readonly text: string,
        readonly position?: number,
    ) {
        super();
    }

    eq(other: PrettyHtmlCommentWidget): boolean {
        return other.text === this.text && other.position === this.position;
    }

    toDOM(): HTMLElement {
        const wrapper = document.createElement("span");
        wrapper.className = "cm-magic-comment-pretty";
        wrapper.textContent = this.text || tr("syntax.widget.comment.default");
        wrapper.title = tr("syntax.widget.comment.editRaw");
        attachSyntaxEditInteractions(wrapper, { position: this.position });
        return wrapper;
    }

    ignoreEvent(): boolean {
        return true;
    }
}
